<template>
  <div class="d-flex calendar-filter">
    <div>
      <action-button
        id="calendar-filter-btn"
        :iright="iRightFilter"
        variant="success px-3 ml-1"
        @click="onToggleFilter"
      >
        <img class="mr-2" :src="barsFilterIcon" />
        Filtrar
      </action-button>

      <div
        class="d-flex justify-content-end mt-3 calendar-filter-content"
        v-if="isFilterOpen"
      >
        <validation-observer ref="formRef" novalidate>
          <div class="modal-content border-0">
            <div class="modal-header px-4">
              <h5 class="modal-title">
                <div class="d-inline mr-2">
                  <img :src="barsFilterIcon" />
                </div>
                Filtrar Búsqueda
              </h5>
            </div>
            <div class="modal-body px-4">
              <div class="px-2">
                <div class="row">
                  <div class="col-12 col-lg-6 mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-drop-down
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Año Fiscal:"
                        :options="academicyears"
                        placeholder="Seleccione"
                        v-model="model.academicYear"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">{{ name }}</span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-input
                        label="Estudiante, Número de Referido o Número de SIE:"
                        icon="fas fa-search text-orange"
                        left-icon
                        :error="errors[0]"
                        v-model="model.student"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6  mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-drop-down
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Estatus:"
                        :options="statuses"
                        placeholder="Seleccione"
                        v-model="model.status"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">{{ name }}</span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="col-12 col-lg-6  mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-drop-down
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Actividad:"
                        :options="activities"
                        placeholder="Seleccione"
                        :disabled="isEvaluation"
                        v-model="model.activity"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">{{ name }}</span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6  mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-drop-down
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Proveedor:"
                        :options="providers"
                        placeholder="Seleccione"
                        v-model="model.provider"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">{{ name }}</span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="col-12 col-lg-6  mt-2">
                    <validation-provider v-slot="{ errors }">
                      <custom-drop-down
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Participante:"
                        :options="participants"
                        placeholder="Seleccione"
                        v-model="model.participant"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">{{ name }}</span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                </div>
                <div class="my-4">
                  <action-button
                    id="calendar-filter-apply-btn"
                    variant="success px-3 w-100"
                    @click="onFilter"
                  >
                    <img class="mr-2" :src="barsFilterIcon" />
                    Filtrar
                  </action-button>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';

const FilterTypes = {
  ShowAll: 1,
  Evaluations: 2,
  Activities: 3,
};

export default {
  name: 'CalendarFilter',
  components: {
    ActionButton,
    CustomDropDown,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    academicyears: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    providers: {
      type: Array,
      default: () => [],
    },
    participants: {
      type: Array,
      default: () => [],
    },
    activities: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    isFilterOpen: false,
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    iRightFilter() {
      const value = 'fa fa-xs';
      return this.isFilterOpen
        ? `${value} fa-chevron-up`
        : `${value} fa-chevron-down`;
    },
    barsFilterIcon() {
      return require('@/assets/icons/bars-filter.svg');
    },
    isEvaluation() {
      return this.selectedFilters == FilterTypes.Evaluations;
    },
  },
  watch: {
    isFilterOpen(value) {
      if (value) this.handlerCalculatePostitionModal();
    },
  },
  methods: {
    handlerCalculatePostitionModal() {
      const btn = document.getElementById('calendar-filter-btn');
      setTimeout(() => {
        const modal = document.querySelector('.calendar-filter-content');
        if (modal) {
          modal.style.right = `15px`;
        }
      }, 5);
    },
    onToggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.$emit('toggle-filter', this.isFilterOpen);
    },
    onFilter() {
      this.$refs.formRef.validate().then((success) => {
        if (success) {
          this.$emit('filter');
          this.isFilterOpen = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.calendar-filter-content {
  position: absolute;
  z-index: 100;
  right: 0 !important;
}
.calendar-filter .modal-dialog {
  position: unset !important;
}

.calendar-filter .modal-content {
  width: 50rem;
}

.calendar-filter .modal-header {
  box-shadow: 0px 3px 6px #00000029;
}
.calendar-filter .modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
}

.calendar-filter .modal-title > div {
  padding: 5px 10px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.filter-selection-tag {
  border-radius: 30px;
  font-weight: 700;
}
.filter-selection-tag > i {
  font-size: 18px;
}

button[disabled].ab-btn.ab-btn-outline-success {
  color: #959595 !important;
  font-weight: 700 !important;
  border-color: #959595 !important;
}
button[disabled].ab-btn.ab-btn-success,
button[disabled].ab-btn.ab-btn-orange {
  color: #959595 !important;
  font-weight: 700 !important;
  border-color: #959595 !important;
  background: #e2e2e2 !important;
}
button[disabled].ab-btn.ab-btn-success img,
button[disabled].ab-btn.ab-btn-orange img {
  filter: invert(69%) sepia(2%) saturate(16%) hue-rotate(338deg) brightness(86%)
    contrast(84%);
}
#calendar-filter-btn {
  height: 40px;
}

@media only screen and (max-width: 750px) {
  .calendar-filter .modal-content {
    width: 100%;
  }
}
</style>
